import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const HeroSection = () => {
    const scrollToContact = () => {
        document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
    }

    const scrollToGallery = () => {
        document.getElementById('galeria')?.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <section className="relative min-h-screen flex items-center justify-center bg-background overflow-hidden">
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-5">
                <div 
                    className="absolute inset-0"
                    style={{
                        backgroundImage: `linear-gradient(90deg, hsl(var(--foreground)) 1px, transparent 1px),
                        linear-gradient(hsl(var(--foreground)) 1px, transparent 1px)`,
                        backgroundSize: '100px 100px'
                    }}
                />
            </div>

            {/* Vertical accent line */}
            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-32 bg-primary" />

            <div className="container mx-auto px-4 md:px-8 relative z-10">
                <div className="max-w-4xl">
                    <span className="inline-block text-primary font-medium tracking-widget uppercase text-sm mb-6 opacity-0 animate-fade-in" style={{ animationDelay: '0.2s' }}>
                        Meble na wymiar
                    </span>

                    <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 opacity-0 animate-fade-in" style={{ animationDelay: '0.4s' }}>
                        Bartkiewicz
                        <span className="block text-primary">Meble</span>
                    </h1>

                    <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-10 opacity-0 animate-fade-in" style={{ animationDelay: '0.6s' }}>
                        Tworzymy meble na wymiar, które łączą funkcjonalność z eleganckim designem.
                        Każdy projekt dopasowujemy do Twoich potrzeb i przestrzeni.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in" style={{ animationDelay: '0.8s' }}>
                        <Button
                            size="lg"
                            onClick={scrollToContact}
                            className="group bg-primary text-primary-foreground hover:bg-primary/90 px-8"
                        >
                            Zamów wycenę
                            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </Button>
                        <Button
                            size="lg"
                            variant="outline"
                            onClick={scrollToGallery}
                            className="border-foreground/20 hover:bg-foreground/5 text-foreground hover:text-foreground"
                        >
                            Zobacz realizacje
                        </Button>
                    </div>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-0 animate-fade-in" style={{ animationDelay: '1.2s' }}>
                <div className="w-6 h-10 border-2 border-foreground/20 rounded-full flex justify-center">
                    <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-bounce" />
                </div>
            </div>
        </section>
    );
}

export default HeroSection;